import { HTTP_STATUS_CODES } from '../components/constants';
import config from '../config';

export interface AccessCheckResponse {
  authorized: boolean;
  securityProfileId?: string;
  securityProfileName?: string;
  message?: string;
}

export const accessCheck = async (agentArn: string): Promise<AccessCheckResponse> => {
  const apiUrl = config.catoApiUrl;

  if (!apiUrl) {
    throw new Error('Agent Allocation API Url is not configured');
  }

  const url = `${apiUrl}/access-check`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ agentArn })
    });

    const data = (await response.json()) as AccessCheckResponse;
    const formattedData = (typeof data === 'string' ? JSON.parse(data) : data) as AccessCheckResponse;

    if (response.status === HTTP_STATUS_CODES.FORBIDDEN) {
      return {
        authorized: false,
        securityProfileId: formattedData.securityProfileId,
        securityProfileName: formattedData.securityProfileName,
        message: formattedData.message
      };
    }

    if (!response.ok) {
      throw new Error(`Failed to check authorization: ${response.status} ${response.statusText}`);
    }

    return formattedData;
  } catch (error) {
    console.error('Error checking authorization:', error);
    throw error;
  }
};
